import React, { useCallback } from 'react';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';
import { useDialogWizardState } from '@futrli/ui-components/components/dialog-wizard/shared/useDialogWizardState';

import { WorkspaceNameUpdatedWizardScreen } from './screens/workspace-name-updated-wizard-screen';
import { WorkspaceNameUpdatingWizardScreen } from './screens/workspace-name-updating-wizard-screen';
import { WorkspaceSettingsFormWizardScreen } from './screens/workspace-settings-form-wizard-screen';
import { useWorkspaceSettingsContext } from '../context/workspace-settings-context';

interface WorkspaceSettingsContainerProps {
  onClose: () => void;
}

export const WorkspaceSettingsContainer = ({ onClose }: WorkspaceSettingsContainerProps) => {
  const { form, view } = useWorkspaceSettingsContext();

  const handleSubmit = useCallback(() => {
    view.updateWorkspace(form.getRequestData());
  }, [form, view]);

  const { screen, handleAction } = useDialogWizardState({
    isLoading: view.state.isUpdating,
    error: view.state.errorUpdating,
    onAction: handleSubmit,
    onClose,
    validate: form.validate
  });

  if (view.state.isLoading) {
    return <LoadingWizardScreen />;
  }

  switch (screen) {
    case 'loading': {
      return <WorkspaceNameUpdatingWizardScreen />;
    }
    case 'success': {
      return <WorkspaceNameUpdatedWizardScreen onClose={onClose} />;
    }
    default: {
      return (
        <WorkspaceSettingsFormWizardScreen
          onClose={onClose}
          onUpdate={handleAction}
          error={view.state.errorUpdating?.message}
        />
      );
    }
  }
};
